import React, { useState } from 'react'
import { useNavigate } from "react-router-dom"

import {AppBar, Box, Icon, IconButton, MenuItem, Toolbar, Typography,Menu, Badge, Avatar,Drawer, Button} from "@mui/material"
import {HelpOutline, MenuRounded, Expand, ExpandMore, ExpandLess, MenuBookTwoTone, MenuBook}from "@mui/icons-material"

import avatar from "../images/Nav/avatar.png"
import { useDispatch, useSelector } from 'react-redux'
import {axiosPrivate} from "../axios/axios"
import { masterAPI } from '../Pages/Masters/dataConfig'
import NotificationDropdown from '../Pages/NotificationInbox/NotificationDropdown'
import SignalRService from '../utils/SignalRService'

const Nav = (props) => {

  const navigate=useNavigate()
  const dispatch=useDispatch()
 
  const [anchorELNavQuestion,setAnchorElNavQues]=useState(null)
  const [anchorELNavimg,setAnchorElNavimg]=useState(null)

  const siteInfoDetail=useSelector(state=>state.auth.loginInfo);

  const handleDrawerOpen = () => {
    props.drawerOpen()
   
  };

  const handleCloseNavMenu = () => {
    setAnchorElNavQues(null);
  };

  const handleArrowimg = (event) => {
    setAnchorElNavimg(event.currentTarget);
  };
  const handleCloseNavimg = () => {
    setAnchorElNavimg(null);
  };

  const handleArrow = (event) => {
    setAnchorElNavQues(event.currentTarget);
  };

      const handleRoleMenu=async()=>{
        const importLink = masterAPI["import"].cloneMenusForSiteAdmin;
        await axiosPrivate
        .post(`${importLink}`)
        .then((res)=>{
        }).catch((e)=>{
          console.log(e, "roleerror");
        })
       }
  

  return (
    <AppBar position="fixed" elevation={0} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 ,backgroundColor:"#2362B4"}}>
   <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",width:"100%",p:{xs:"0.2rem 0.5rem",sm:"0.2rem 1.3rem"}}}>
      <Box sx={{display:"flex",alignItems:"center",gap:{xs:"0.2rem",sm:"0.5rem"}}}>
    <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={{display:{xs:"none",md:"block"}}}
      >
        <MenuRounded sx={{fontSize:'2.2rem'}} />
      </IconButton>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={{display:{xs:"block",md:"none"},p:{xs:"0.4rem",sm:"0.6rem"}}}
      >
        <MenuRounded sx={{fontSize:{xs:'1.7rem',sm:'2.2rem'}}} />
      </IconButton>
      <Typography variant="h6" noWrap  sx={{fontSize:{xs:"1rem",sm:"1.4rem"}}}>
     Oriens EAM
      </Typography>
      </Box>
      <Box sx={{display:"flex",alignItems:"center",gap:{xs:"0.2rem",sm:"1.3rem"}}}>
        <IconButton onClick={handleArrow} sx={{display:{xs:"none",sm:"inline-flex"}}}>
          <HelpOutline sx={{color:"white"}}/>
        </IconButton>
        <Menu   anchorEl={anchorELNavQuestion}
          open={Boolean(anchorELNavQuestion)}
          onClose={handleCloseNavMenu}>
          <Typography sx={{color:"#6C757D",fontSize:"14px",p:"8px 16px"}}>Header</Typography>
          <MenuItem>Another Action</MenuItem>
          <MenuItem>Another Action</MenuItem>
        </Menu>
        <NotificationDropdown />
        <IconButton  sx={{ display: siteInfoDetail.menuList.length === 0 ? {xs:"none",sm:"inline-flex"} : "none" }}  onClick={handleRoleMenu}>
          <MenuBook sx={{color:"white"}}/>
        </IconButton>
<Box sx={{display:"flex",alignItems:"center"}}>
<Avatar alt="image" src={`${avatar}`}   sx={{ width: {xs:28,sm:34}, height: {xs:28,sm:34},boxShadow:"0 0 4px 2px white" }} />
<IconButton onClick={handleArrowimg} sx={{p:{xs:"0.3rem",sm:"0.6rem"}}}>{Boolean(anchorELNavimg)?<ExpandLess sx={{color:"white"}}/>: <ExpandMore sx={{color:"white"}}/>}</IconButton>
</Box>
<Menu   anchorEl={anchorELNavimg}
          open={Boolean(anchorELNavimg)}
          onClose={handleCloseNavimg}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}>
          {/* <Typography sx={{color:"#6C757D",fontSize:"14px",p:"8px 16px"}}>Header</Typography>
          <MenuItem>Another Action</MenuItem>
          <MenuItem>Another Action</MenuItem> */}
        <MenuItem
         onClick={async ()=>{
          const signout=masterAPI["user"].signout
          // axiosPrivate.get(`${signout}`).then(res=>{
          //   dispatch({type:"logout",payload:{}})
          //   dispatch({type:"menuType",payload:[]})
          //   dispatch({type:"actionsAllow",payload:{}})
          //   navigate("/")
          // // dispatch({type:"logout",payload:false})
          // navigate("/")
          // }).catch(e=>{
          //   console.log(e,"error")
          // })
          await SignalRService.leaveGroup(siteInfoDetail.id)
          SignalRService.stop()
          dispatch({type:"logout",payload:{}})
          dispatch({type:"menuType",payload:[]})
          dispatch({type:"actionsAllow",payload:{}})
          navigate("/")
          // // dispatch({type:"logout",payload:false})
         
          

        }}
          >Logout</MenuItem>
        </Menu>
      </Box>
      </Box>
  </AppBar>
  )
}

export default Nav